'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** Grid framework for responsive content */
var Col = function Col(_ref) {
  var children = _ref.children,
      htmlId = _ref.htmlId,
      props = _objectWithoutProperties(_ref, ['children', 'htmlId']);

  delete props.bsClass;

  return _react2.default.createElement(
    _Col2.default,
    Object.assign({ id: htmlId }, props),
    children
  );
};

Col.propTypes = {
  /** Base CSS class and prefix for the component. */
  bsClass: _propTypes2.default.string,

  /** Any child components. */
  children: _propTypes2.default.node,

  /** Component className. */
  className: _propTypes2.default.string,

  /** Specify a custom wrapper element type. */
  componentClass: _propTypes2.default.string,

  /** Globally unique and descriptive HTML ID. Used by QA for automated testing. */
  htmlId: _propTypes2.default.string,

  /** The number of columns you wish to span for large devices (≥1200px). */
  lg: _propTypes2.default.number,

  /** Hide column on large devices. */
  lgHidden: _propTypes2.default.bool,

  /** Move columns to the right for large devices. */
  lgOffset: _propTypes2.default.number,

  /** Change the order of grid columns to the left for large devices. */
  lgPull: _propTypes2.default.number,

  /** Change the order of grid columns to the right for large devices. */
  lgPush: _propTypes2.default.number,

  /** The number of columns you wish to span for medium devices (≥992px). */
  md: _propTypes2.default.number,

  /** Hide column on medium devices. */
  mdHidden: _propTypes2.default.bool,

  /** Move columns to the right for medium devices. */
  mdOffset: _propTypes2.default.number,

  /** Change the order of grid columns to the left for medium devices. */
  mdPull: _propTypes2.default.number,

  /** Change the order of grid columns to the right for medium devices. */
  mdPush: _propTypes2.default.number,

  /** The number of columns you wish to span for small devices (≥768px). */
  sm: _propTypes2.default.number,

  /** Hide column on small devices. */
  smHidden: _propTypes2.default.bool,

  /** Move columns to the right for small devices tablets. */
  smOffset: _propTypes2.default.number,

  /** Change the order of grid columns to the left for small devices. */
  smPull: _propTypes2.default.number,

  /** Change the order of grid columns to the right for small devices. */
  smPush: _propTypes2.default.number,

  /** The number of columns you wish to span for extra small devices (<768px). */
  xs: _propTypes2.default.number,

  /** Hide column on extra small devices. */
  xsHidden: _propTypes2.default.bool,

  /** Move columns to the right for extra small devices. */
  xsOffset: _propTypes2.default.number,

  /** Change the order of grid columns to the left for extra small devices. */
  xsPull: _propTypes2.default.number,

  /** Change the order of grid columns to the right for extra small devices. */
  xsPush: _propTypes2.default.number
};

Col.defaultProps = {
  componentClass: 'div'
};

exports.default = Col;


//////////////////
// WEBPACK FOOTER
// ../fusion-ui-components/lib/Col/Col.js
// module id = 407
// module chunks = 2